import { Component, OnInit, Input } from '@angular/core';
import { Booking, FareType, TourOrExperience, Package, Sector } from '../../../shared/models/booking.model';
import * as _ from 'lodash';
import * as lodash from 'lodash';
import { LocalStorageService } from './../../../shared/services/local-storage.service';
import { ProductTypeUrl } from 'app/shared/models/enums/ProductTypeUrl.enum';
import { PrettyPassengerPipe } from 'app/shared/pipes/pretty-passenger.pipe';
import { Passengers } from 'app/shared/models/passenger.model';
import { Availability, RouteOption } from 'app/shared/models/availability.model';
import { GxConstants } from 'app/shared/constants/gx.constants';
import { InitialDataService } from 'app/initial-data.service';
@Component({
    selector: 'gaweb-product-summary',
    templateUrl: 'product-summary.component.html',
    styleUrls: ['./product-summary.component.less']
})
export class ProductSummaryComponent implements OnInit {

    @Input() productName: string;
    @Input() loadingBookings: boolean;
    @Input() allowExpansion: boolean = true;
    showJustPassengerSummary: boolean = false;
    @Input()
    productType: ProductTypeUrl;
    private _bookings: Array<Booking>;
    @Input() set bookings(value: Array<Booking>) {
        this._bookings = value;
        if (value && value.length > 0 && this.productType !== ProductTypeUrl.expressBooking && this.productType !== ProductTypeUrl.manageBooking) {
            this.bootstrapFromBookings();
        }
    }
    get bookings(): Array<Booking> {
        return this._bookings;
    }
    data: Booking;
    passengerSummary: string;
    summarisedProducts: string[] = [];
    ProductTypeUrl = ProductTypeUrl;
    constructor(private localStorageService: LocalStorageService,
        private initialDataService: InitialDataService) { }

    ngOnInit() {
        let booking;
        switch (this.productType) {
            case ProductTypeUrl.accommodation:
                break;
            case ProductTypeUrl.experience:
                this.allowExpansion = false;
                //this.showJustPassengerSummary = true;
                break;
            case ProductTypeUrl.package:
                break;
            case ProductTypeUrl.travelPasses:
                break;
            case ProductTypeUrl.expressBooking:
                const passengers: Passengers = this.localStorageService.getTravelPassengers();
                if (!passengers) {
                    window.location.href = this.initialDataService.makeABookingUrl;
                }
                const prettyPassengerPipe = new PrettyPassengerPipe();
                this.passengerSummary = prettyPassengerPipe.transform(passengers);
                booking = this.localStorageService.getOfflineBooking();
                booking.travels = this.toViewModel(booking.travels);
                this.data = booking;
                break;
            default:

        }
        this.SummariseProducts();
    }

    SummariseProducts() {
        let curname, name : string[] = [], qty: number[] = [];
        this._bookings[0].TpProducts.forEach(product => {
            if(product.TicketNumber == null){
                curname = product.Name.split(' x ')[1];
                if(!!name.find(n => n === curname)) {
                    qty[name.indexOf(curname)] += product.QuantityToBook;
                } else {
                    name.push(curname);
                    qty.push(product.QuantityToBook);
                }
            }
        });
        name.forEach(n => {
            this.summarisedProducts.push(qty[name.indexOf(n)] + ' x ' + n);
        });
    }

    bootstrapFromBookings() {
        this.passengerSummary = this.getPassengersSummaryFromBookings();
    }

    isMinDate(dateToTest: string) {
        return dateToTest === GxConstants.MIN_DATE;
    }

    private getPassengersSummaryFromBookings = () => {
        let mainObj = Booking.getMainObject(this.bookings[0], this.productType, false); // TODO check
        const fareTypesMap = {};
        this.bookings.forEach((booking: Booking) => {
            mainObj = Booking.getMainObject(booking, this.productType, false); 
            let mainObjArr: TourOrExperience[] | Package[] = mainObj;
            if (!(mainObj instanceof Array)) {
                mainObjArr = [mainObj];
            }
            _(mainObjArr)
                .forEach((tourOrPackage: any) => {
                    let selectedFareTypeCode = tourOrPackage.SelectedFareType;
                    if (booking.Package.SelectedFareType != null) {
                        selectedFareTypeCode = booking.Package.SelectedFareType;
                    } 
                    let selectedFareType: FareType = tourOrPackage.FareTypes.find(f => f.FareTypeCode === selectedFareTypeCode);
             
                    if (booking.Package.SelectedFareType != null) {
                        selectedFareType = booking.Package.FareTypes.find(f => f.FareTypeCode === selectedFareTypeCode);
                    } 


                    if (!!selectedFareType) {
                        const key: string = selectedFareType.Farebasis.DisplayDescription || (selectedFareType.OnlineName || selectedFareType.Description);
                        if (!!fareTypesMap[key]) {
                            fareTypesMap[key]++;
                        } else {
                            fareTypesMap[key] = 1;
                        }
                    }
                });
        });
        
        let summary = '';
        for (const fareType of Object.keys(fareTypesMap)) {  // IE11 Requires that we use Object.keys instead of Object.entries
            const quantity = fareTypesMap[fareType];
            summary += `${quantity} x ${fareType}`;
            if (fareType !== Object.keys(fareTypesMap)[Object.keys(fareTypesMap).length - 1]) {
                summary += ', ';
            }
        }
        return summary;
    }
    // ADD FRONT-END SPECIFIC PROPERTIES ON 'TRAVEL_AVAILABILITY' OBJECT FROM SERVER
    private toViewModel(travels: Availability[]) {

        _.each(travels,
            function (ta) {
                // ROUTE OPTIONS
                lodash.each(ta.RouteOptions,
                    function (ro: RouteOption & { collapsed: boolean, BusesNumber: string, IsWifiEnabledService: boolean }) {
                        ro.collapsed = true;

                        // ROUTE SECTORS
                        lodash.each(ro.Sectors,
                            function (se: Sector & { BusNumber: string }) {
                                se.BusNumber = se.ServiceCompany + se.ServiceNumber;
                            });

                        // ROUTE SECTORS SUMMARY
                        ro.BusesNumber = lodash.map(ro.Sectors, 'BusNumber').join(',');
                        ro.IsWifiEnabledService = !!ro.Sectors.find(
                            function (se) {
                                return se.IsWifiEnabledService;
                            });
                    });
            });

        return travels;
    }
}



// WEBPACK FOOTER //
// ./src/app/travel-products/product-passenger-details/product-summary/product-summary.component.ts